import {createFileRoute, redirect} from '@tanstack/react-router'

/** Redirect legacy create-project step URLs to /jobs/create. */
export const Route = createFileRoute('/_app/projects/create/$')({
    beforeLoad: () => {
        throw redirect({to: '/jobs/create', replace: true})
    },
})
